module.exports = __webpack_public_path__ + "img/cooperation.428e6a10.svg";